import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { SHADOW_PROJECT_TYPE } from '../../../constants';
import { useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { NavigationWrapper } from '../../ui';

type Props = React.PropsWithChildren<RouteComponentProps>;

const CustomizationTabs = ({ match, children }: Props): JSX.Element => {
  const {
    customizeWidgetPath,
    dashboardPath,
    emailCustomizationPath,
    navigationPath,
    smsCustomizationPath
  } = usePaths();
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();
  const { currentProject } = useCurrentProject(projectId);

  const tabItems = [
    {
      label: intl.formatMessage({ id: 'widget-customization.tabs.widget' }),
      href: customizeWidgetPath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'widget-customization.tabs.email' }),
      href: emailCustomizationPath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'widget-customization.tabs.sms' }),
      href: smsCustomizationPath(projectId)
    }
  ];

  const shadowTabItems = [
    {
      label: intl.formatMessage({ id: 'widget-customization.tabs.email' }),
      href: emailCustomizationPath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'widget-customization.tabs.sms' }),
      href: smsCustomizationPath(projectId)
    }
  ];

  const breadCrumbsOptions = [
    {
      label: intl.messages['dashboard.label'],
      to: dashboardPath()
    },
    {
      label: currentProject?.name,
      to: navigationPath(projectId)
    },
    {
      label: intl.messages['widget-customization.breadcrumb.label'],
      to: `#`
    }
  ];

  return (
    <NavigationWrapper
      breadCrumbsOptions={breadCrumbsOptions}
      tabsItems={currentProject?.type === SHADOW_PROJECT_TYPE ? shadowTabItems : tabItems}
      dataTestId="customization-settings">
      {children}
    </NavigationWrapper>
  );
};

export default withRouter(CustomizationTabs);
